import * as React from 'react';
import AlignContext from "./AlignContext";
import Box from "../Box"; // An empty text node that uses a zero-width space (\u200B) via a ::before
// pseudo-element to establish baseline of the alignment reference within the
// baseline alignment group.

const TextAligner = () => /*#__PURE__*/React.createElement(AlignContext.Consumer, null, ({
  lineHeight,
  size
}) => {
  if (!size) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Box, {
    className: "TextAligner",
    "aria-hidden": "true",
    flexBasis: "auto",
    flexGrow: 0,
    flexShrink: 0,
    style: {
      lineHeight: `${lineHeight}px`,
      fontSize: `${size}px`
    }
  });
});

export default TextAligner;